import { render } from "./Fitness.vue?vue&type=template&id=400dde9a"
import script from "./Fitness.vue?vue&type=script&lang=js"
export * from "./Fitness.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__